module.exports = __webpack_public_path__ + "static/img/content.5fe4262.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/sakura/recall/content.png
// module id = DRC3
// module chunks = 6